import { apiSlice } from '@/store/api/apiSlice';
import { getTransitTimestamp, WeekType } from '@/utils/getTransitTimestamp';

export interface PlanetaryTransitItem {
  sign: string;
  planet: string;
  degree: string;
  nakshatra: string;
  pada: number;
  awastha: string;
  retro: boolean;
}

export interface PlanetaryTransitResponse {
  date: string;
  transit: PlanetaryTransitItem[];
}

export const weeklyPlanetaryTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyPlanetaryTransit: builder.query<PlanetaryTransitResponse, { weekType?: WeekType }>({
      query: ({ weekType = 'current' }: { weekType?: WeekType } = {}) => ({
        url: '/transits/general-planetry-transit',
        method: 'GET',
        params: {
          timestamp: getTransitTimestamp('weekly', weekType),
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetWeeklyPlanetaryTransitQuery } = weeklyPlanetaryTransitApi;
